import * as Blockly from 'blockly/core'

// 標準ブロック（math_number / operator 系など）を登録する副作用 import。
import 'blockly/blocks'
// カスタムブロック定義を登録する副作用 import。
// これが無いと serialization.load が未知ブロック型で失敗する。
import '../blocks/blocks'

/**
 * 保存済みワークスペースデータ（オブジェクト名 → Blockly シリアライズ状態）から、
 * おためしプレイ実行用のヘッドレス Blockly.Workspace 群を構築する。
 *
 * キーはミッション定義の objects[].name（例 '①ピンクのかべ'）と一致させ、
 * `createRuntime` の workspaces 引数にそのまま渡せる形にする。
 */
export const buildWorkspaces = (
  saved: Record<string, Record<string, unknown>>,
): Map<string, Blockly.Workspace> => {
  const workspaces = new Map<string, Blockly.Workspace>()
  for (const [name, data] of Object.entries(saved)) {
    const workspace = new Blockly.Workspace()
    try {
      Blockly.serialization.workspaces.load(data, workspace)
    } catch (error) {
      // 失敗中の workspace と、既にロード済みの全 workspace を破棄してからthrow。
      workspace.dispose()
      for (const loaded of workspaces.values()) {
        loaded.dispose()
      }
      throw new Error(
        `おためしプレイ用ワークスペースの読み込みに失敗しました（${name}）: ${String(error)}`,
      )
    }
    workspaces.set(name, workspace)
  }
  return workspaces
}
